import React from "react"
import { ariane, arianeHereDetail, arianeHome } from "./ariane.module.scss"
import PropTypes from "prop-types"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import { ArianeSection } from "./ariane-styled"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"

//-----------------------Component---------------------------//

const Ariane = ({ isDetail, isListing, pageName, pageNameLink, postName }) => {
  const buildColors = useBuildData().theme_settings.palette
  return (
    <ArianeSection
      className={ariane}
      role="navigation"
      aria-label="Vous êtes ici :"
    >
      <ol>
        <li className={arianeHome}>
          <AniLink paintDrip hex={buildColors.a_color_gradients.a_dark} to="/">
            Accueil
          </AniLink>
        </li>
        {isListing && <li aria-label="Vous êtes ici :">{pageName}</li>}
        {isDetail && !pageName ? (
          <li>
            <p>
              <span>{postName}</span>
            </p>
          </li>
        ) : isDetail && pageName ? (
          <>
            <li>
              <TransitionFade link={pageNameLink}>{pageName}</TransitionFade>
            </li>
            <li className={arianeHereDetail} aria-label="Vous êtes ici :">
              {postName}{" "}
            </li>
          </>
        ) : null}
      </ol>
    </ArianeSection>
  )
}
//-----------------------Component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//

Ariane.propTypes = {
  isListing: PropTypes.bool,
  isDetail: PropTypes.bool,
  pageName: PropTypes.string.isRequired,
  pageNameLink: PropTypes.string,
  postName: PropTypes.string,
}
//-----------------------Prop-Types---------------------------//

export default Ariane
